<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    style="display: flex"
  >
    <!-- 中 -->
    <div class="" style="flex: 2">
      <div class="worms-cont-top">
        <div style="display: none">
          {{ devItem.deviceAddr }}
        </div>
        <div
          class="worms-cont-top-box"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <b>{{ item.name }}</b>
          <p></p>
          <div class="worms-cont-top-type">
            <div>
              {{
                item.type == 0
                  ? item.value == 0
                    ? "已关闭"
                    : "已开启"
                  : item.value
              }}
              <i
                :style="
                  item.value == 0
                    ? 'background: #FFFFFF;'
                    : 'background: #18FEF0;'
                "
              ></i>
            </div>
            <p>{{ item.state }}{{ item.unit }}</p>
          </div>
        </div>
      </div>
      <div class="worms-cont-bottom">
        <!-- <div style="border: 1px solid green;">
					<div class="cx-worms-right-top" style="border: 1px solid red;">
						<div class="cx-worms-right-img">
							<img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701744536550.png" alt="">
						</div>
						<div class="cx-worms-right-text">
							<p>杀虫仓、烘干仓温度数据统计</p>
							<div style="display: none;">
								{{devItem.deviceAddr}}
							</div>
							<div style="display: flex">
								<div class="cx-worms-right-i">
									<i></i>
									杀虫仓
								</div>
								<div class="cx-worms-right-i">
									<i style="background: #18FEFE;"></i>
									杀虫仓
								</div>
							</div>
						</div>
						<div class="cx-worms-right-hr"></div>
					</div>
					<div class="worms-bottom-data" style="border: 1px solid red;">
						<div id="mainOne" style="width: 100%;height: 220px;"></div>
						<div class="worms-bottom-data-left">
							<div class="worms-bottom-data-box">
								<ul class="worms-bottom-data-ul1">
									<li style="opacity: 0.1;"></li>
									<li style="opacity: 0.2;"></li>
									<li style="opacity: 0.3;"></li>
									<li style="opacity: 0.4;"></li>
									<li style="opacity: 0.5;"></li>
									<li style="opacity: 0.6;"></li>
									<li style="opacity: 0.7;"></li>
									<li style="opacity: 0.8;"></li>
									<li style="opacity: 0.9;"></li>
									<li style="opacity: 1;"></li>
								</ul>
								杀虫仓
							</div>
							<div class="worms-bottom-data-box">
								<ul class="worms-bottom-data-ul2">
									<li style="opacity: 0.1;"></li>
									<li style="opacity: 0.2;"></li>
									<li style="opacity: 0.3;"></li>
									<li style="opacity: 0.4;"></li>
									<li style="opacity: 0.5;"></li>
									<li style="opacity: 0.6;"></li>
									<li style="opacity: 0.7;"></li>
									<li style="opacity: 0.8;"></li>
									<li style="opacity: 0.9;"></li>
									<li style="opacity: 1;"></li>
								</ul>
								烘干仓
							</div>
						</div>
					</div>
				</div> -->
        <div v-if="showWormsList.createTime" style="display: flex">
          <!-- <img  :src="showWormsList.imagesUrl"  style="width: 298px; height: 298px; margin-right: 20px" alt=""> -->
          <el-image
            style="width: 298px; height: 298px; margin-right: 20px"
            :src="showWormsList.imagesUrl"
            lazy
            :preview-src-list="srcList"
          >
          </el-image>
          <div class="worms-cont-bottom-text">
            <div>采集于：</div>
            {{ showWormsList.createTime }}
          </div>
        </div>

        <!-- <div class="worms-bottom-title">
					<b>光照度统计</b>
					<p>[] GUANGZHAODUTONGJI</p>
				</div>
				<div id="mainTwo" style="width: 100%;height: 220px;"></div> -->
        <div class="worms-tip-box-bg">
          <img
            src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701747283627.png"
            alt=""
          />
          <div>虫情趋势分析</div>
        </div>
        <div id="mainThree" style="width: 100%; height: 220px"></div>
      </div>
    </div>
    <!-- 中 End -->
    <!-- 右 -->
    <div class="" style="flex: 1; display: flex; justify-content: flex-end">
      <div style="width: 90%">
        <div class="cx-worms-right-item">
          <div class="cx-worms-right-top">
            <div class="cx-worms-right-img">
              <img
                src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701744536550.png"
                alt=""
              />
            </div>
            <div class="cx-worms-right-text">
              <p>实时虫情</p>
              <p>近日虫情采集数据</p>
            </div>
            <div class="cx-worms-right-hr"></div>
          </div>
          <div class="cx-worms-right-list">
            <div
              v-if="wormsList.length == 0"
              style="display: flex; justify-content: center"
            >
              <el-empty
                :image-size="75"
                description="暂无设备"
                image="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705376475598.png"
              ></el-empty>
            </div>
            <div
              v-for="(item, index) in wormsList"
              :key="index"
              @click="chooseItem(item)"
            >
              <!-- <img :src="item.imagesUrl" alt=""  style="width: 72px; height: 72px; margin-right: 20px"> -->
              <el-image
                style="width: 72px; height: 72px; margin-right: 20px"
                :src="item.imagesUrl"
                lazy
                :preview-src-list="srcList"
              >
              </el-image>
              <div class="cx-worms-right-list-text">
                {{ item.createTime }}
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 25px">
          <div style="display: flex; justify-content: start">
            <div>
              <el-radio-group
                v-model="mapRadio"
                size="mini"
                @change="mapRadioOnChange()"
              >
                <el-radio-button label="标准"></el-radio-button>
                <el-radio-button label="卫星"></el-radio-button>
                <el-radio-button label="3D地图"></el-radio-button>
                <el-radio-button label="3D室内地图"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="width: 40%">
              <el-input
                placeholder="请输入经纬度"
                v-model="mapLat"
                class="input-with-select"
                style=""
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchMapLat()"
                ></el-button>
              </el-input>
            </div>
          </div>
        </div>
        <div v-if="mapRadio == '标准'" style="margin-top: 5px">
          <el-radio-group
            v-model="mapRadioType"
            @change="mapRadioTypeOnChange()"
          >
            <el-radio label="normal">标准</el-radio>
            <el-radio label="dark">幻影黑</el-radio>
            <el-radio label="light">月光银</el-radio>
            <el-radio label="whitesmoke">远山黛</el-radio>
            <el-radio label="fresh">草色青</el-radio>
            <el-radio label="grey">雅士灰</el-radio>
            <el-radio label="blue">靛青蓝</el-radio>
            <el-radio label="darkblue">极夜蓝</el-radio>
          </el-radio-group>
        </div>

        <div
          class="cx-warm-map"
          :style="mapRadio != '标准' ? 'height:460px' : ''"
          style="margin-top: 15px"
        >
          <div id="container"></div>
        </div>
      </div>
    </div>
    <!-- 右 End -->
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <span>当前设备暂无数据</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script
  type="text/javascript"
  src="https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.CitySearch"
></script>
<script>
import * as echarts from "echarts";
export default {
  name: "app",
  components: {},
  props: {
    // 当前活动tab的索引
    devItem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      mapLat: "",
      mapRadio: "标准",
      mapRadioType: "normal",
      dataList: [
        {
          name: "移虫装置",
          state: "状态",
          type: 0,
          value: 0,
          unit: "",
        },
        {
          name: "震动装置",
          state: "状态",
          type: 0,
          value: 0,
          unit: "",
        },
        {
          name: "补光灯",
          state: "状态",
          type: 0,
          value: 0,
          unit: "",
        },
        {
          name: "杀虫控制",
          state: "状态",
          type: 0,
          value: 0,
          unit: "",
        },
        {
          name: "烘干装置",
          state: "状态",
          type: 0,
          value: 0,
          unit: "",
        },
        {
          name: "摄像头",
          state: "状态",
          type: 0,
          value: 0,
          unit: "",
        },
        {
          name: "杀虫仓温度",
          state: "温度",
          type: 1,
          value: "-",
          unit: "℃",
        },
        {
          name: "烘干仓温度",
          state: "温度",
          type: 1,
          value: "-",
          unit: "℃",
        },
        {
          name: "光照度",
          state: "光照",
          type: 1,
          value: "-",
          unit: "Lux",
        },
      ],
      sevenDay: [],
      echartList: [],
      oneChart: {},
      oneOption: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        color: ["#0579FB", "#18FEF0"],
        grid: {
          left: "0%",
          right: "0%",
          top: "10%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [0, 0, 0, 0, 0, 0, 0],
            boundaryGap: false,
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: true,
            },
            axisLabel: {
              formatter: "{value} ℃",
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["#ffffff00", "#ffffff00"],
              },
            },
          },
          {
            type: "value",
            axisLine: {
              show: true,
            },
            axisLabel: {
              formatter: "{value} ℃",
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["#ffffff00", "#ffffff00"],
              },
            },
          },
        ],
        series: [
          {
            name: "杀虫仓",
            type: "line",
            // stack: 'Total',
            smooth: true,
            areaStyle: {
              backgroundColor: "rgba(255, 255, 255, 0.18)",
            },
            emphasis: {
              focus: "series",
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + " ℃";
              },
            },
            data: [0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "烘干仓",
            type: "line",
            // stack: 'Total',
            smooth: true,
            areaStyle: {
              backgroundColor: "rgba(136, 223, 242, 0.32)",
            },
            yAxisIndex: 1,
            emphasis: {
              focus: "series",
            },
            tooltip: {
              valueFormatter: function (value) {
                return value + " ℃";
              },
            },
            data: [0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
      twoChart: {},
      twoOption: {
        // title: {
        // 	text: '光照度统计',
        // 	left: 'left',
        // 	top: 'top',
        // 	textStyle: {
        // 		fontSize: 20,
        // 		fontWeight: 500,
        // 		color: '#FFFFFF'
        // 	}
        // },
        visualMap: [
          {
            show: false,
            type: "continuous",
            dimension: 0,
            min: 0,
            max: 3,
            inRange: {
              color: ["rgba(0, 100, 251, 1)", "rgba(33, 228, 255, 1)"],
            },
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        color: ["rgba(24, 89, 255, 0.32)"],
        grid: {
          left: "3%",
          right: "8%",
          top: "30%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [0, 0, 0, 0, 0, 0, 0],
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位:Lux",
            axisLine: {
              show: true,
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ["rgba(70, 90, 100, 0.67)", "#ffffff00"],
              },
            },
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            // showSymbol: false,
            data: [0, 0, 0, 0, 0, 0, 0],
            tooltip: {
              valueFormatter: function (value) {
                return value + " Lux";
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 2,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(24, 89, 255, 0.32)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(33, 228, 255, 0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      },
      threeChart: {},
      threeOption: {
        dataset: {
          source: [
            ["score", "product"],
            [0, "虫子1"],
            [0, "虫子2"],
            [0, "虫子3"],
            [0, "虫子4"],
          ],
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "3%",
          top: "8%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {},
        yAxis: {
          type: "category",
        },
        visualMap: {
          show: false,
          type: "continuous",
          dimension: 0,
          min: 0,
          max: 3,
          inRange: {
            color: ["rgba(0, 100, 251, 1)", "rgba(33, 228, 255, 1)"],
          },
        },
        series: [
          {
            type: "bar",
            encode: {
              // Map the "amount" column to X axis.
              x: "score",
              // Map the "product" column to Y axis
              y: "product",
            },
          },
        ],
      },
      wormsList: [], //获取实时虫情数据
      beginTime: "",
      beginTimes: "",
      endTime: "",
      srcList: [],
      showWormsList: {},
      map: {},
      oldDevItem: {},
      loading: true,
      userInfo: {},
      centerDialogVisible: false,
    };
  },
  mounted() {
    // 从本地缓存中获取数据
    let userInfo = localStorage.getItem("user_info");
    // 将获取到的JSON字符串转换回对象
    this.userInfo = JSON.parse(userInfo);
    console.log("虫情组件---mounted", this.devItem);
    if (this.devItem.deviceAddr) {
      this.init();
    }
  },
  updated() {
    console.log("虫情组件---更新数据重新渲染DOM---devItem", this.devItem);
    this.init();
  },
  beforeDestroy() {
    // console.log('虫情组件---在实例销毁之前调用')
    // this.oneChart.dispose();
    // this.twoChart.dispose();
    if (this.threeChart.id) {
      this.threeChart.dispose();
    }
    this.map.options && this.map.destroy();
  },
  methods: {
    init() {
      if (this.oldDevItem.deviceAddr != this.devItem.deviceAddr) {
        if (this.devItem.status == "offline") {
          console.log("虫情组件init===========离线===========");
        } else {
          console.log("虫情组件init======================");
        }
        if (this.threeChart.id) {
          this.threeChart.dispose();
          this.threeChart = {};
        }
        this.loading = true;
        this.getSevenDay();
        this.getRealTimeData();
        this.getThirtyData();
        this.oldDevItem = this.devItem;
      } else {
        console.log("虫情组件init重复======================");
      }
    },
    getSevenDay() {
      var dates = [];
      for (var i = 6; i >= 0; i--) {
        var date = new Date();
        date.setDate(date.getDate() - i);
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        var day = date.getDate().toString().padStart(2, "0");
        var formattedDate = `${year}-${month}-${day}`;
        dates.push(formattedDate);
      }
      this.sevenDay = dates;
      // console.log('getSevenDay', dates);
      this.initAllEchart();
    },
    initAllEchart() {
      // 判断是否echarts是否初始化过
      if (!this.threeChart.id) {
        console.time("初始化所有Echart---");
        // if (this.oneChart) {
        // 	this.oneChart = echarts.init(document.getElementById('mainOne'));
        // }
        // this.oneOption.xAxis[0].data = this.sevenDay;
        // this.oneChart.setOption(this.oneOption);

        // if (this.twoChart) {
        // 	this.twoChart = echarts.init(document.getElementById('mainTwo'));
        // }
        // this.twoOption.xAxis[0].data = this.sevenDay;
        // this.twoChart.setOption(this.twoOption);

        this.threeChart = echarts.init(document.getElementById("mainThree"));
        // this.threeOption.xAxis[0].data = this.sevenDay;
        this.threeChart.setOption(this.threeOption);
        console.timeEnd("初始化所有Echart---");
      }
      // this.getEchart();
      this.getThreeEchart();

      this.map.options && this.map.destroy();
      this.map = {};
      this.newMap();
    },
    getThreeEchart() {
      console.log("=========getThreeEchart=========");
      let httpData = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
        groupId: this.devItem.groupId, //'76157347S38B0S4238SB556S9F46C7074DE9',
        beginTime: this.beginTimes,
        endTime: this.endTime,
      };
      console.log("虫情组件---getThreeEchart-httpData===", httpData);
      this.$axios
        .get("/FourEmotions/getDeviceWormStatistics", {
          params: httpData,
        })
        .then((ress) => {
          console.log("虫情组件---getThreeEchart-res===", ress);
          if (ress.data && ress.data.length != 0) {
            let wornData = ress.data[0].wornData;
            let wornDataList = [["score", "product"]];
            for (let j in wornData) {
              let dataList = [];
              dataList.push(wornData[j].num, wornData[j].name);
              wornDataList.push(dataList);
            }
            this.threeOption.dataset.source = wornDataList;
            this.threeChart.setOption(this.threeOption);
          } else {
            // console.log('统计图没数据，加载默认this.threeOption', this.threeOption)
            this.threeOption.dataset.source = [
              ["score", "product"],
              [0, "虫子1"],
              [0, "虫子2"],
              [0, "虫子3"],
              [0, "虫子4"],
            ];
            this.threeChart.setOption(this.threeOption);
          }
        })
        .catch((error) => {
          console.log("虫情组件---getThreeEchart-error===", error);
        });
    },
    getEchart() {
      console.log("=========getEchart=========");
      let httpData = {
        seachType: 1,
        deviceAddr: this.devItem.deviceAddr, //'40160490' //设备ID
      };
      this.$axios
        .get("/FourEmotions", {
          params: httpData,
        })
        .then((ress) => {
          console.log("虫情组件---getEchart-res===", ress);
          if (ress.data.length != 0) {
            let res = ress.data;
            for (let i in res) {
              let array = {};
              let xData = [];
              let yData = [];
              array.name = Object.keys(res[i])[0].split(",")[0];
              array.uni =
                Object.keys(res[i])[0].split(",")[1] == "null"
                  ? ""
                  : Object.keys(res[i])[0].split(",")[1];
              array.res = Object.values(res[i])[0];
              for (let j in array.res) {
                xData.push(array.res[j].x);
                yData.push(array.res[j].y);
              }
              array.xData = xData;
              array.yData = yData;

              if (array.name.includes("杀虫仓温度")) {
                this.oneEchart1(array);
              }
              if (array.name.includes("烘干仓温度")) {
                this.oneEchart2(array);
              }
              if (array.name.includes("光照度")) {
                this.twoEchart(array);
              }
            }
          }
        })
        .catch((error) => {
          console.log("虫情组件---getEchart-error===", error);
        });
    },
    // oneEchart1(array) {
    // 	console.log("杀虫仓温度--oneEchart1--", array);
    // 	this.oneOption.xAxis[0].data = array.xData;
    // 	this.oneOption.series[0].data = array.yData;

    // 	this.oneChart.setOption(this.oneOption);
    // },
    // oneEchart2(array) {
    // 	console.log("烘干仓温度--oneEchart2--", array);
    // 	this.oneOption.xAxis[0].data = array.xData;
    // 	this.oneOption.series[1].data = array.yData;

    // 	this.oneChart.setOption(this.oneOption);
    // },
    twoEchart(array) {
      console.log("光照度--twoEchart--", array);
      this.twoOption.xAxis[0].data = array.xData;
      this.twoOption.series[0].data = array.yData;

      this.twoChart.setOption(this.twoOption);
    },
    getRealTimeData() {
      //设备数据
      let httpData = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
        deviceAddrs: this.devItem.deviceAddr, //"0412230001",
      };
      this.$axios
        .get("/FourEmotions/getRealTimeData", {
          params: httpData,
        })
        .then((res) => {
          console.log("getRealTimeData设备数据-res===", res);
          if (res.data.length != 0) {
            let data = res.data[0].data;
            this.dataList[0].value = data.moveWorm;
            this.dataList[1].value = data.shake;
            this.dataList[2].value = data.fillLight;
            this.dataList[3].value = data.insecticide;
            this.dataList[4].value = data.drying;
            this.dataList[5].value = data.camera;
            this.dataList[6].value = data.insecticideTem;
            this.dataList[7].value = data.dryingTem;
            this.dataList[8].value = data.illum;
          } else {
            this.centerDialogVisible = true;
          }
        })
        .catch((error) => {
          console.log("getRealTimeData设备数据-error===", error);
          if (
            error.msg ==
            "运行时异常:syntax error, pos 1, line 1, column 2访问过于频繁"
          ) {
            this.$message.error("访问过于频繁");
          }
        });
    },
    getThirtyData() {
      // 获取当前时间
      var currentDate = new Date();

      // 获取当前时间14天后的日期
      var futureDates = new Date();
      futureDates.setDate(futureDates.getDate() - 14);
      // 格式化日期为 yyyy-MM-dd HH:mm:ss
      function formatDate(date) {
        var year = date.getFullYear();
        var month = ("0" + (date.getMonth() + 1)).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);
        var hours = ("0" + date.getHours()).slice(-2);
        var minutes = ("0" + date.getMinutes()).slice(-2);
        var seconds = ("0" + date.getSeconds()).slice(-2);
        return (
          year +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds
        );
      }

      // 获取当前时间30天后的日期
      var futureDate = new Date();
      futureDate.setDate(futureDate.getDate() - 30);
      // 格式化日期为 yyyy-MM-dd HH:mm:ss
      function formatDate(date) {
        var year = date.getFullYear();
        var month = ("0" + (date.getMonth() + 1)).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);
        var hours = ("0" + date.getHours()).slice(-2);
        var minutes = ("0" + date.getMinutes()).slice(-2);
        var seconds = ("0" + date.getSeconds()).slice(-2);
        return (
          year +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds
        );
      }
      // 格式化当前时间和30天后的时间
      this.endTime = formatDate(currentDate);
      this.beginTime = formatDate(futureDate);
      this.beginTimes = formatDate(futureDates);

      this.wormsList = [];
      this.getDeviceData();
    },
    getDeviceData() {
      //获取实时虫情数据
      let httpData = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
        deviceAddr: this.devItem.deviceAddr, //"0412230001",
        beginTime: this.beginTime,
        endTime: this.endTime,
        deviceType: "wormFlagship",
      };
      this.$axios
        .get("/FourEmotions/getDeviceData", {
          params: httpData,
        })
        .then((res) => {
          console.log("getDeviceData获取实时虫情数据-res===", res);
          for (let i in res.data.rows) {
            this.showWormsList = res.data.rows[0];
            this.srcList.push(
              res.data.rows[0].imagesUrl.replace("http://images.auto.0531yun.cn/wormImages/", "https://web.dxnyyun.com/images/")
            );
            res.data.rows[i].imagesUrl = res.data.rows[i].imagesUrl.replace(
              "http://images.auto.0531yun.cn/wormImages/",
              "https://web.dxnyyun.com/images/"
            );
            this.wormsList.push(res.data.rows[i]);
            console.log("getDeviceData获取实时虫情数据-res===", this.wormsList);
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log("getDeviceData获取实时虫情数据-error===", error);
          this.loading = false;
        });
    },
    chooseItem(item) {
      // console.log('chooseItem===', item);
      this.showWormsList = item;
      this.srcList = [];
      this.srcList.push(item.imagesUrl);
    },
    mapRadioOnChange() {
      this.newMap();
      this.mapRadioType = "normal";
    },
    mapRadioTypeOnChange() {
      console.log("--mapRadioTypeOnChange--", this.mapRadioType);
      var styleName = "amap://styles/" + this.mapRadioType;
      this.map.setMapStyle(styleName);
    },
    searchMapLat() {
      this.newMap();
      this.mapRadioType = "normal";
    },
    newMap() {
      let lngLat = this.mapLat != "" ? this.mapLat.split(",") : [];

      if (lngLat.length > 0) {
        lngLat.push(lngLat[0]);
        lngLat.push(lngLat[1]);
      }
      let scripts = [];
      if (this.mapRadio == "标准") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6",
          "https://cache.amap.com/lbs/static/es5.min.js",
        ];
      } else if (this.mapRadio == "卫星") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=Map3D",
        ];
      } else if (this.mapRadio == "3D地图") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.ControlBar",
        ];
      } else if (this.mapRadio == "3D室内地图") {
        scripts = [
          "https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.ToolBar",
          "https://webapi.amap.com/demos/js/liteToolbar.js",
        ];
      }

      scripts.forEach((src) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
          // 外部 JS 文件加载成功后的回调函数
          // console.log('气象newMap加载成功');

          // 这是中心点的经纬度
          // 业务中应该是获取当前位置
          if (this.mapRadio == "标准") {
            this.map = new AMap.Map("container", {
              resizeEnable: true, //是否监控地图容器尺寸变化
              mapStyle: "amap://styles/fresh",
              zoom: this.mapLat != "" ? 6 : 13, //初始化地图层级
              center: this.mapLat != "" ? lngLat : [this.devItem.devicelng,this.devItem.devicelat], // 初始化地图中心点
            });
          } else if (this.mapRadio == "卫星") {
            this.map = new AMap.Map("container", {
              center: this.mapLat != "" ? lngLat : [this.devItem.devicelng,this.devItem.devicelat], // 初始化地图中心点
              zoom: this.mapLat != "" ? 14 : 13, //初始化地图层级
              mapStyle: "amap://styles/fresh",
              features: ["road", "bg"],
            });

            let satellite = new AMap.TileLayer.Satellite({
              map: this.map,
            });
          } else if (this.mapRadio == "3D地图") {
            this.map = new AMap.Map("container", {
              resizeEnable: true,
              rotateEnable: true,
              pitchEnable: true,
              zoom: this.mapLat != "" ? 14 : 17, //初始化地图层级
              pitch: 80,
              rotation: -15,
              viewMode: "3D", //开启3D视图,默认为关闭
              buildingAnimation: true, //楼块出现是否带动画

              expandZoomRange: true,
              zooms: [3, 20],
              center: this.mapLat != "" ? lngLat : [this.devItem.devicelng,this.devItem.devicelat], // 初始化地图中心点
            });

            this.map.addControl(
              new AMap.ControlBar({
                showZoomBar: false,
                showControlButton: true,
                position: {
                  right: "10px",
                  top: "10px",
                },
              })
            );
          } else if (this.mapRadio == "3D室内地图") {
            this.map = new AMap.Map("container", {
              resizeEnable: true,
              center: this.mapLat != "" ? lngLat : [this.devItem.devicelng,this.devItem.devicelat], // 初始化地图中心点
              zoom: this.mapLat != "" ? 14 : 18, //初始化地图层级
              pitch: 50,
              viewMode: "3D",
            });

            this.map.on("indoor_create", function () {
              this.map.indoorMap.showIndoorMap("B000A856LJ", 5);
            });
          }

          if (lngLat.length > 0) {
            // 点标记显示内容，HTML要素字符串
            const markerContent =
              "" +
              '<div class="custom-content-marker">' +
              '   <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705998876110.gif">' +
              "</div>";
            let lngLons = lngLat[0];
            let lngLats = lngLat[1];
            const position = new AMap.LngLat(lngLons, lngLats); // Marker经纬度
            const marker = new AMap.Marker({
              position: position,
              content: markerContent, // 将 html 传给 content
              offset: new AMap.Pixel(-13, -30), // 以 icon 的 [center bottom] 为原点
            });
            this.map.add(marker);
          }
          this.loading = false;
        };
        script.onerror = (err) => {
          // 外部 JS 文件加载失败后的回调函数
          // console.log('虫情newMap加载失败', err);
        };
        document.head.appendChild(script);
      });
    },
  },
};
</script>

<!-- <style>
	@import url("https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css");
</style> -->
<style>
.worms-bottom-data-ul2 li {
  background: #fe8618;
}

.worms-bottom-data-ul1 li {
  background: #ffffff;
}

.worms-bottom-data-box ul li {
  list-style: none;
  width: 26px;
  height: 11px;
}

.worms-bottom-data-box ul {
  /* width: 36px; */
  height: 111px;
  border: 1px solid #808082;
  padding: 4px;
  margin-bottom: 5px;
}

.worms-bottom-data-box {
  font-size: 12px;
  color: #fafafc;
}

.worms-bottom-data-left {
  display: flex;
  width: 90px;
  justify-content: space-between;
  align-items: center;
}

.worms-bottom-data {
  margin-top: 20px;
  display: flex;
}

.worms-bottom-title b {
  font-size: 24px;
  color: #ffffff;
}

.worms-bottom-title p {
  color: #18fef0;
  font-size: 12px;
}

.worms-bottom-title {
  margin-top: 33px;
  margin-bottom: 15px;
}

.worms-cont-bottom > div {
  width: 100%;
}

.worms-cont-bottom {
  margin-top: 20px;
  /* flex-wrap: wrap; */
}

.cx-worms-right-i {
  font-size: 14px;
  color: #ffffff;
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.cx-worms-right-i i {
  width: 15px;
  height: 2px;
  background: #ffffff;
  margin-right: 8px;
  display: inline-block;
}

.worms-cont-top {
  display: grid;
  grid-template-columns: auto auto auto auto auto auto auto;
  gap: 35px 0px;
  justify-content: space-between;
}

.worms-cont-top-box {
  width: 110px;
  line-height: 19px;
}

.worms-cont-top-box > b {
  color: #fff;
  font-size: 18px;
}

.worms-cont-top-box > p {
  font-size: 10px;
  color: #909090;
  padding: 4px 0 8px 0;
}

.worms-cont-top-type {
  height: 62px;
  background: rgba(255, 255, 255, 0.08);
  padding: 10px;
}

.worms-cont-top-type div {
  font-size: 14px;
  color: #ffffff;
}

.worms-cont-top-type i {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 50%;
  margin-left: 20px;
}

.worms-cont-top-type p {
  font-size: 12px;
  color: #c5c5c5;
  line-height: 22px;
}

.custom-content-marker img {
  width: 100%;
  height: 100%;
}

#container {
  width: 100%;
  height: 100%;
}

/* 地图 */

.cx-worms-right-list-text {
  width: calc(100% - 92px);
  font-size: 16px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  line-height: 24px;
}

.cx-worms-right-list img {
  width: 72px;
  height: 72px;
  margin-right: 20px;
}

.cx-worms-right-list > div {
  display: flex;
  margin-bottom: 21px;
  padding: 0 4px;
}

.cx-worms-right-list {
  height: 320px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  margin-top: 25px;
}

.cx-worms-right-list::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
}

.cx-worms-right-list::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.cx-worms-right-hr {
  width: 12px;
  height: 40px;
  border-bottom: 3px #18fefe solid;
  margin-left: 3px;
}

.cx-worms-right-text {
  line-height: 44px;
  border-bottom: 1px rgba(255, 255, 255, 0.5) solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 50px);
  height: 40px;
  font-size: 16px;
  font-weight: bold;
}

.cx-worms-right-img {
  width: 34px;
  border-bottom: 3px #fff solid;
  padding: 12px 0 9px 0;
  text-align: center;
}

.cx-worms-right-img img {
  width: 20px;
  height: 20px;
}

.cx-worms-right-top {
  width: 100%;
  height: 40px;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
}

.cx-worms-right-item {
  background: transparent;
}

/* 地图 */

.cx-worms-map {
  width: 100%;
  height: 420px;
  margin-top: 50px;
}

.worms-cont-bottom-text {
  font-size: 24px;
  color: #ffffff;
}

.worms-cont-bottom-text div {
  margin-bottom: 30px;
}

.worms-tip-box-bg {
  width: 100%;
  height: 44px;
  background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701757063603.png)
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}

.worms-tip-box-bg img {
  width: 20px;
  height: 20px;
  margin-right: 7px;
}

.worms-tip-box-bg div {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}
</style>
